/*
 * INO Beauty - 2500 TL ve uzeri siparislerde ucretsiz Termal Canta
 * Urun ara toplami (kupon/kargo haric) esigi gectiginde cantayi sepete
 * otomatik ekler, esigin altina dustugunde otomatik cikarir.
 * FoxEcom Sleek temasinin native sepet akisini (cartUpdate pubsub) kullanir.
 */
(function () {
  if (window.__inoFreeGiftInit) return;
  window.__inoFreeGiftInit = true;

var GIFT_VARIANT_ID = 54052365730068;
var THRESHOLD = 420000; // 4200,00 TL (kuruş)

  function eligibleTotal(cart) {
    return ((cart && cart.items) || []).reduce(function (sum, it) {
      return it.variant_id === GIFT_VARIANT_ID ? sum : sum + it.original_line_price;
    }, 0);
  }

  function formatMoney(cents) {
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL';
  }

  // Sepet basligindaki hediye esik cubugu (snippets/free-gift-goal.liquid).
  // Drawer basligi section render'inda yenilenmedigi icin cart:updated
  // olayiyla guncellenir (free-shipping-goal ile ayni desen).
  if (window.customElements && !customElements.get('free-gift-goal')) {
    customElements.define(
      'free-gift-goal',
      class extends HTMLElement {
        connectedCallback() {
          this.onCartUpdated = this.onCartUpdated || this.handleCartUpdated.bind(this);
          document.addEventListener('cart:updated', this.onCartUpdated);
          this.update(Number(this.dataset.eligibleTotal) || 0);
        }
        disconnectedCallback() {
          document.removeEventListener('cart:updated', this.onCartUpdated);
        }
        handleCartUpdated(event) {
          var cart = event && event.detail && event.detail.cart;
          if (!cart || !cart.items) return;
          this.update(eligibleTotal(cart));
        }
        update(amount) {
          this.classList.toggle('hidden', amount <= 0);
          this.classList.toggle('free-gift-goal--done', amount >= THRESHOLD);
          var bar = this.querySelector('progress-bar');
          if (bar) bar.style.setProperty('--percent', Math.min((amount * 100) / THRESHOLD, 100) + '%');
          if (amount < THRESHOLD) {
            var left = this.querySelector('[data-left-to-spend]');
            if (left) left.innerHTML = formatMoney(THRESHOLD - amount);
          }
        }
      }
    );
  }

  if (window.Shopify && window.Shopify.designMode) return;

  function whenReady(cb) {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.routes && FoxTheme.utils) return cb();
    var tries = 0;
    var timer = setInterval(function () {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.routes && FoxTheme.utils) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 150);
  }

  whenReady(function () {
    var working = false;

    function fetchCfg(type) {
      try { return FoxTheme.utils.fetchConfig(type || 'json'); }
      catch (e) {
        return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      }
    }

    function bundledSections() {
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
      return sections;
    }

    function getCart() {
      return fetch(FoxTheme.routes.cart_url, { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    }

    function findGift(cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].variant_id === GIFT_VARIANT_ID) return items[i];
      }
      return null;
    }

    // Sepeti yeniden cek, render edilmis section'lari ekle ve temanin
    // cartUpdate olayini yayinla -> drawer + header sayaci native guncellenir.
    function broadcast(operationResponse) {
      return getCart().then(function (cart) {
        if (operationResponse && operationResponse.sections) cart.sections = operationResponse.sections;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'ino-free-gift', cart: cart });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
        return cart;
      });
    }

    function addGift() {
      var body = JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _ino_free_gift: 'true' } }],
        sections: bundledSections(),
        sections_url: window.location.pathname
      });
      return fetch(FoxTheme.routes.cart_add_url, Object.assign({}, fetchCfg('json'), { body: body }))
        .then(function (r) { return r.json(); })
        .then(broadcast);
    }

    // change.js, satir anahtarini (key) bekler; ciplak varyant ID kabul etmez.
    function changeGiftLine(key, qty) {
      var body = JSON.stringify({
        id: key,
        quantity: qty,
        sections: bundledSections(),
        sections_url: window.location.pathname
      });
      return fetch(FoxTheme.routes.cart_change_url, Object.assign({}, fetchCfg('json'), { body: body }))
        .then(function (r) { return r.json(); })
        .then(broadcast);
    }

    function reconcile(knownCart) {
      if (working) return Promise.resolve();
      var source = knownCart && knownCart.items ? Promise.resolve(knownCart) : getCart();
      return source.then(function (cart) {
        var gift = findGift(cart);
        var hasOtherItems = ((cart && cart.items) || []).some(function (it) {
          return it.variant_id !== GIFT_VARIANT_ID;
        });
        var qualifies = hasOtherItems && eligibleTotal(cart) >= THRESHOLD;

        if (qualifies) {
          if (!gift) { working = true; return addGift().finally(function () { working = false; }); }
          if (gift.quantity !== 1) { working = true; return changeGiftLine(gift.key, 1).finally(function () { working = false; }); }
        } else if (gift) {
          working = true; return changeGiftLine(gift.key, 0).finally(function () { working = false; });
        }
      }).catch(function () { working = false; });
    }

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (working) return;
      if (event && event.source === 'ino-free-gift') return;
      reconcile(event && event.cart && event.cart.items ? event.cart : null);
    });

    document.addEventListener('cart:refresh', function () {
      if (working) return;
      setTimeout(function () { reconcile(); }, 700);
    });

    window.addEventListener('pageshow', function () { reconcile(); });

    // "Hemen Satin Al" (dynamic checkout) sepeti atlayip dogrudan checkout'a
    // gidiyor. Yakalayip once urunu sepete ekliyoruz; reconcile cantayi ekler;
    // ardindan checkout'a yonlendiriyoruz. Boylece hizli satin alma yolunda da
    // 2500 TL ustu hediye uygulanir.
    function buyNowThenCheckout(form, btn) {
      var fd;
      try { fd = new FormData(form); } catch (e) { window.location.href = '/cart'; return; }
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none'; btn.style.opacity = '0.7'; }
      fetch(FoxTheme.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status !== 200) throw new Error('add-failed');
          return reconcile();
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart'; });
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('.shopify-payment-button__button--unbranded');
      if (!btn) return;
      var form = btn.closest('form[action*="/cart"]') || btn.closest('form');
      if (!form) return;
      var idEl = form.querySelector('[name="id"]');
      if (!idEl || !idEl.value || idEl.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      buyNowThenCheckout(form, btn);
    }, true);

    reconcile();
  });
})();
